<template>
  <div class="container" style="background:var(--bg3);color:var(--text3);">
    <div style="padding:5px;border-bottom:1px solid var(--border)">我的角色</div>

    <div style="margin:5px 0;margin-bottom:15px;font-size:18px;padding:10px 20px;">
      <Dropdown trigger="click" transfer @on-click="$store.commit('cm/change_role',$event)">
      <a style="color:var(--primary)">{{my_role.name}} <BaseIcon icon="ios-arrow-down" style="margin-left:10px" v-if="my_roles.length > 0" /></a>
      <p style="font-size:12px;color:var(--subtext1)">{{my_role.desc}}</p>
      <DropdownMenu slot="list">
        <template v-for="r in my_roles.filter(v=>v.id != my_role.id)">
          <DropdownItem :key="r.id" :name="r.id" style="font-size:16px">{{r.name}}</DropdownItem>
        </template>
      </DropdownMenu>
      </Dropdown>
    </div>

  </div>

</template>

<script>
import {mapGetters} from 'vuex';
export default {
  computed: {
    ...mapGetters('cm', ['my_role', 'my_roles']),
  },
};
</script>

<style lang="scss" scoped>

</style>
